// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csae-view__container {
    background: var(--white-color);
    border-radius: 8px;
    width: 900px;
    padding: 60px 70px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 96px;
    margin-bottom: 24px;
}

.csae-view__container .baloa-headline-2 {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-bold);
    text-align: center;
}

.csae-view__container .baloa-subtitle-1 {
    color: var(--primary-very-dark-color);
    margin-top: 40px;
}

.csae-view__container .baloa-normal {
    color: var(--primary-very-dark-color);
    margin-top: 22px;
    list-style-type: disc;
}

.csae-view__container .baloa-normal.link a {
    color: var(--new-green-color);
    cursor: pointer;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .csae-view__container {
        border-radius: 0;
        border-top: 1px solid var(--new-gray-background-color);
        width: 100%;
        padding: 24px;
        margin-top: 0;
        margin-bottom: 0;
    }

    .csae-view__container ol {
        padding-inline-start: 24px;
    }

    .csae-view__container ol  .baloa-normal.full-text {
        margin-left: -18px;
    }

    .csae-view__container ul {
        padding-inline-start: 6px;
    }

    .csae-view__container .baloa-subtitle-1 {
        margin-top: 24px;
    }

    .csae-view__container .baloa-normal {
        margin-top: 16px;
    }

    .csae-view__container ol  .baloa-normal.sec-email {
        margin-left: -24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/csae/views/CsaeView.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,gBAAgB;QAChB,sDAAsD;QACtD,WAAW;QACX,aAAa;QACb,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".csae-view__container {\n    background: var(--white-color);\n    border-radius: 8px;\n    width: 900px;\n    padding: 60px 70px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 96px;\n    margin-bottom: 24px;\n}\n\n.csae-view__container .baloa-headline-2 {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-bold);\n    text-align: center;\n}\n\n.csae-view__container .baloa-subtitle-1 {\n    color: var(--primary-very-dark-color);\n    margin-top: 40px;\n}\n\n.csae-view__container .baloa-normal {\n    color: var(--primary-very-dark-color);\n    margin-top: 22px;\n    list-style-type: disc;\n}\n\n.csae-view__container .baloa-normal.link a {\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .csae-view__container {\n        border-radius: 0;\n        border-top: 1px solid var(--new-gray-background-color);\n        width: 100%;\n        padding: 24px;\n        margin-top: 0;\n        margin-bottom: 0;\n    }\n\n    .csae-view__container ol {\n        padding-inline-start: 24px;\n    }\n\n    .csae-view__container ol  .baloa-normal.full-text {\n        margin-left: -18px;\n    }\n\n    .csae-view__container ul {\n        padding-inline-start: 6px;\n    }\n\n    .csae-view__container .baloa-subtitle-1 {\n        margin-top: 24px;\n    }\n\n    .csae-view__container .baloa-normal {\n        margin-top: 16px;\n    }\n\n    .csae-view__container ol  .baloa-normal.sec-email {\n        margin-left: -24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
